import script from "./StaticImage.vue?vue&type=script&setup=true&lang=js"
export * from "./StaticImage.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__